const getDevType = (context) => {
  function getType () {
    var u = navigator.userAgent
    if (!!u.match(/compatible/i) || u.match(/Windows/i)) {
      return 'pc'
    } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
      return 'pc'
    } else if (!!u.match(/iphone/i) || u.match(/Ipad/i)) {
      return 'h5'
    } else if (u.match(/android/i)) {
      return 'h5'
    } else if (u.match(/Ubuntu/i)) {
      return 'pc'
    } else {
      return 'pc'
    }
  }

  document, addEventListener('resize', () => {
    context.devType = getType()
  })

  context.devType = getType()
}

const formatNumber = (n) => {
  n = n.toString()
  const v = n[1] ? n : '0' + n
  return v
}

const getDateObj = (dateString) => {
  const createTimeDate = new Date(dateString)
  return {
    year: createTimeDate.getFullYear().toString(),
    month: formatNumber(createTimeDate.getMonth() + 1),
    day: formatNumber(createTimeDate.getDate())
  }
}

export default {
  getDevType,
  getDateObj
}
